export default "__VITE_ASSET__773585c3__"